import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function taskTemplatesSubTasksActionReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_TASK_TEMPLATES_SUB_TASKS_ACTION_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_TASK_TEMPLATES_SUB_TASKS_ACTION_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_TASK_TEMPLATES_SUB_TASKS_ACTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
